// ⚠️ 카리면접 디자인 리스킨(체크포인트-디자인) — blue/red/yellow 스케일을 카리면접 토큰으로 리맵.
//    키는 그대로라 587개 사용처가 자동으로 카리면접 색으로 전환된다. 되돌리려면 `체크포인트-디자인` 브랜치 참고.
const colors = {
  // blue* → 카리면접 primary. 앱은 blue600 을 주 액센트(버튼·활성메뉴·링크)로 쓰므로
  // blue600/500 = 카리 브랜드 #3B82F6(밝게). 700~900 은 hover/진한 용도라 과하지 않게.
  blue900: "#12479E",
  blue800: "#1D4ED8",
  blue700: "#2563EB",
  blue600: "#3B82F6",
  blue500: "#3B82F6",
  blue400: "#659BF3",
  blue300: "#90B7F7",
  blue200: "#B0CCFA",
  blue100: "#CDDFFC",
  blue50: "#EAF1FE",

  green900: "#006935",
  green800: "#00894B",
  green700: "#009B58",
  green600: "#00AE66",
  green500: "#00BD71",
  green400: "#04C886",
  green300: "#56D29C",
  green200: "#8FDFB9",
  green100: "#BCEBD4",
  green50: "#E3F7EE",

  // yellow* → 카리면접 warning (amber)
  yellow900: "#C77800",
  yellow800: "#EC9500",
  yellow700: "#FFB000",
  yellow600: "#FFBB1A",
  yellow500: "#FFC93D",
  yellow400: "#FFCE59",
  yellow300: "#FFE199",
  yellow200: "#FEEBBA",
  yellow100: "#FEF5DC",
  yellow50: "#FFFCF0",

  orange600: "#FF984D",
  orange100: "#FF6D38",
  orange50: "#FFECDB",
  gray900: "#1B1D1F",
  gray800: "#26282B",
  gray600: "#464C52",
  gray500: "#73787E",
  gray400: "#9FA4A8",
  gray200: "#C9CDD3",
  gray100: "#E9EBED",
  gray50: "#F7F8F9",

  black: "#000000",
  white: "#FFFFFF",

  // red* → 카리면접 danger (coral)
  red900: "#A81E17",
  red800: "#C42A20",
  red700: "#E03328",
  red600: "#F0483C",
  red500: "#F85F57",
  red400: "#F98781",
  red300: "#FAB0AB",
  red200: "#FBC5C1",
  red100: "#FDDAD8",
  red50: "#FEF1F0",

  success: "#36A3FF",

  warning: "#EE4C69",
  warning70: "#FFD3DB",
  warning50: "#FDE5E9",
  warning100: "#EE4C69",

  tableHover: "#EEF6FD",

  calendarBlue: "#6EC3F2",
  calendarPurple: "#A07CF5",
  calendarRed: "#FF6565",
  calendarPink: "#EFA3C6",
  calendarGray: "#8DA4BE",

  attendance100: "#00B66D",
  attendance50: "#E3F7EE",
  absence100: "#FF6D38",
  absence50: "#FFECDB",
  late100: "#FAA820",
  late50: "#FFF7D6",
  pending100: "#73787E",
  pending50: "#E9EBED",
};

export default colors;
